import {
  Box,
  Button,
  FormControlLabel,
  Switch,
  TextField,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { tokens } from "../app/theme";
import { parseList } from "./pluginValidation";
import {
  useApplicationConfig,
  usePersistApplicationConfig,
} from "./useApplicationConfig";

export function MicrosoftShiftsPluginForm() {
  const config = useApplicationConfig();
  const persist = usePersistApplicationConfig();
  const shifts = config.plugins.microsoftShifts;

  const [enabled, setEnabled] = useState(shifts.enabled);
  const [markedOutSyncEnabled, setMarkedOutSyncEnabled] = useState(
    shifts.markedOutSyncEnabled
  );
  const [teamIds, setTeamIds] = useState(shifts.teamIds.join("\n"));

  useEffect(() => {
    setEnabled(shifts.enabled);
    setMarkedOutSyncEnabled(shifts.markedOutSyncEnabled);
    setTeamIds(shifts.teamIds.join("\n"));
  }, [shifts]);

  function save(): void {
    persist({
      ...config,
      plugins: {
        ...config.plugins,
        microsoftShifts: {
          ...shifts,
          enabled,
          markedOutSyncEnabled,
          teamIds: parseList(teamIds),
        },
      },
    }).catch(() => {
      /* error already surfaced via app feedback */
    });
  }

  return (
    <Box display="flex" flexDirection="column" gridGap={16} marginTop={2}>
      <FormControlLabel
        control={
          <Switch
            color="primary"
            checked={enabled}
            onChange={(event) => setEnabled(event.target.checked)}
            inputProps={{ "data-testid": "shifts-enabled" } as any}
          />
        }
        label="Enabled"
      />
      <FormControlLabel
        control={
          <Switch
            color="primary"
            checked={markedOutSyncEnabled}
            onChange={(event) => setMarkedOutSyncEnabled(event.target.checked)}
            inputProps={{ "data-testid": "shifts-marked-out" } as any}
          />
        }
        label="Marked-out / time-off sync"
      />
      <TextField
        label="Team IDs"
        value={teamIds}
        onChange={(event) => setTeamIds(event.target.value)}
        multiline
        minRows={2}
        variant="outlined"
        helperText="One Microsoft Teams team ID per line."
        inputProps={{ "data-testid": "shifts-team-ids" }}
      />
      <Box>
        <Button
          variant="contained"
          color="primary"
          onClick={save}
          data-testid="shifts-save"
        >
          Save Shifts settings
        </Button>
      </Box>
      <Box style={{ color: tokens.fg3, fontSize: 12 }}>
        Shifts uses the shared Microsoft tenant settings. Microsoft Graph
        credentials stay in secure storage and are never edited here.
      </Box>
    </Box>
  );
}
